
/*
 *   File : delete-account.js
 *   Author URI : https://evoqins.com
 *   Description :Modal component to show confirmation to remove customer details from our database.
 *   Integrations : null
 *   Version : v1.1
 */

// Packages
import { Fragment, memo, useEffect } from "react";

// Custom components
import { SecondaryButton } from "../Buttons";

// Custom styles
import style from "../../Styles/Components/delete-account.module.scss";


const DeleteAccountModal = (props) => {

    useEffect(() => {
        var my_modal = document.getElementById("delete-profile");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.closeModal();
        });
        //eslint-disable-next-line
    }, []);


    // Close the modal and redirect the user to the support ticket page
    const _handleRaiseTicket = () => {
        document.getElementById("close").dispatchEvent(new Event("click"));
        props.onRaiseTicket();
    }

    return (
        <Fragment>
            <div className={`modal fade ${style.e_delete_account}`}
                id="delete-profile"
                tabIndex="-1"
                aria-labelledby="delete-profile"
                aria-hidden="true"
                data-bs-keyboard="false" >
                <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                    <div className={`modal-content pb-4  text-center px-3 ${style.e_content} `}>
                        <span id="close"
                            className="d-none"
                            data-bs-dismiss="modal" ></span>
                        <Fragment>
                            <img src={require("../../Assets/Images/Modal/delete.png")}
                                alt="success"
                                draggable={false}
                                width={144}
                                height={144}
                                className="mx-auto" />
                            <h5 className="e-font-16 e-line-height-24 e-montserrat-semi-bold color-eerie-black mb-2">
                                Account Deletion
                            </h5>

                            {props.ineligible === true ?
                                // Account cannot be deleted -> show the reason + helpdesk contact / raise a ticket
                                <Fragment>
                                    <p className="e-montserrat-medium e-font-16 e-line-height-28 color-charcoal-gray mb-2 ">
                                        {props.reason}
                                    </p>
                                    <p className="e-montserrat-medium e-font-14 e-line-height-24 color-charcoal-gray mb-0 ">
                                        For more details, please contact{" "}
                                        <a href={`mailto:${props.supportEmail}`}
                                            rel="noreferrer"
                                            className="e-montserrat-semi-bold color-rebecca-purple text-decoration-none text-transform-lower">
                                            {props.supportEmail}
                                        </a>{" "}
                                        or{" "}
                                        <span className="e-montserrat-semi-bold color-rebecca-purple cursor-pointer text-decoration-underline"
                                            onClick={_handleRaiseTicket}>
                                            raise a ticket
                                        </span>
                                    </p>
                                    <div className="row mt-4">
                                        <div className="col-12">
                                            <SecondaryButton label="Close"
                                                cancel="modal"
                                                className="w-100 padding-12px-tb" />
                                        </div>
                                    </div>
                                </Fragment>
                                :
                                // Eligible -> deletion is no longer self-service; route the user to support
                                <Fragment>
                                    <p className="e-montserrat-medium e-font-16 e-line-height-28 color-charcoal-gray mb-2 ">
                                        To delete your account, please contact our support team.
                                    </p>
                                    <p className="e-montserrat-medium e-font-14 e-line-height-24 color-charcoal-gray mb-0 ">
                                        Reach out to{" "}
                                        <a href={`mailto:${props.supportEmail}`}
                                            rel="noreferrer"
                                            className="e-montserrat-semi-bold color-rebecca-purple text-decoration-none text-transform-lower">
                                            {props.supportEmail}
                                        </a>{" "}
                                        or{" "}
                                        <span className="e-montserrat-semi-bold color-rebecca-purple cursor-pointer text-decoration-underline"
                                            onClick={_handleRaiseTicket}>
                                            raise a ticket
                                        </span>
                                    </p>
                                    <div className="row mt-4">
                                        <div className="col-12">
                                            <SecondaryButton label="Close"
                                                cancel="modal"
                                                className="w-100 padding-12px-tb" />
                                        </div>
                                    </div>
                                </Fragment>
                            }

                        </Fragment>

                    </div>

                </div>
            </div>
        </Fragment>
    )
}

DeleteAccountModal.defaultProps = {
    ineligible: false,
    reason: "",
    supportEmail: "",
    closeModal: () => { },
    onRaiseTicket: () => { },
}

export default memo(DeleteAccountModal)
